export const environment = {
  production: false,
  apiBaseUrl: '/api',
  /**
   * Client Payments & Subscription + FE subscription security.
   *
   * false — tenant admins/users/analysts use features free; hide client Billing.
   *         (Match backend SF_REQUIRE_SUBSCRIPTION=0 while Multispares test.)
   * true  — show Payments for tenant admins; unpaid users land on Billing;
   *         402 shows backend detail + Open Billing.
   *
   * Irish Taylor Billing overview is always available (not controlled here).
   */
  showBilling: true
};
